export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Email'
  ],
  'requiredFields': {
    'default': [
      'Company'
    ],
    'consulting': [
      'Company',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'RequestTopic'
    ],
    'other': []
  },
}
